import {
  BodyLG,
  BodyLGB,
  BodyMDB,
  BodyXL,
  Heading2XL,
  Heading3XL,
  Heading5XL,
} from "../../../typography";

import { Link } from "react-router-dom";
import { RiveAnimation } from "../../components/ui/RiveAnimation";
import { StandardButton } from "@verse_core/shared_components/buttons/StandardButton";

export const Hero = () => (
  <div className="tw-relative tw-flex tw-items-center tw-gap-y-[2em]">
    <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-x-[4em] tw-gap-y-[2.625em] min440:tw-flex-row min440:tw-px-[1.5em]">
      <div className="tw-flex tw-w-full tw-flex-col tw-items-center tw-gap-y-[1.5em] tw-text-center min440:tw-w-1/2 min440:tw-items-start min440:tw-text-left">
        <Heading2XL className="tw-my-0 tw-hidden tw-text-white min1040:tw-flex">
          Payor Case Management
        </Heading2XL>

        <Heading5XL className="tw-my-0 tw-hidden tw-text-white min1040:tw-flex">
          Streamline DME coordination for your case managers
        </Heading5XL>
        <Heading3XL className="tw-my-0 tw-text-white min1040:tw-hidden">
          Streamline DME coordination for your case managers
        </Heading3XL>

        <BodyXL className="tw-my-0 tw-hidden tw-max-w-[574px] tw-text-white min440:tw-flex">
          With Verse, case managers eliminate back and forth & maintain order
          visibility through delivery to the member.
        </BodyXL>
        <BodyLG className="tw-my-0 tw-text-white min440:tw-hidden">
          With Verse, case managers eliminate back and forth & maintain order
          visibility through delivery to the member.
        </BodyLG>
        <div className="tw-flex tw-flex-row tw-justify-center min440:tw-mt-[.5em]">
          <StandardButton
            onClick={() => {}}
            style={"primary-blue"}
            className="tw-w-[13.75em] tw-rounded-full tw-px-[2em] tw-py-[1em] tw-text-[16px]"
          >
            <Link to="/contact" className="tw-no-underline">
              <BodyLGB className="tw-my-0 tw-hidden tw-text-white min440:tw-block">
                Book a demo
              </BodyLGB>
              <BodyMDB className="tw-my-0 tw-text-white min440:tw-hidden">
                Book a demo
              </BodyMDB>
            </Link>
          </StandardButton>
        </div>
      </div>
      <div className="tw-aspect-square tw-h-full tw-w-full min440:tw-w-1/2">
        <RiveAnimation
          src="/landing_page_assets/rive/14.riv"
          className="tw-h-full tw-w-full"
          fallbackSrc="/landing_page_assets/payor_case_management_page/table1.png"
          fallbackClassName="tw-h-full tw-w-full"
        />
      </div>
    </div>
  </div>
);
